import {ModalComponentProps, Card, Block, Dialog, DialogBody, DialogFooter, Button, VF} from '@mc/ui-v4';

import {rffFormSubmit} from '@mc/react-app-v4';
import {Form} from 'react-final-form';
import React, {MutableRefObject} from 'react';
import {useQueryClient} from 'react-query';
import {LayerSettingsApi, TopicVO} from '../../../api';
import {CACHE_KEY_TOPICS_MAP} from '../../../hooks/useTopicsMap';
import {MapEditorActions} from '@mc/react-mapio';

type Props = ModalComponentProps & {
    topic: TopicVO;
    mapRef: MutableRefObject<MapEditorActions>;
};

type FormValues = {
    formatovanaLegenda?: string;
};

export const LegendConfigModal: React.FC<Props> = ({onClose, topic, mapRef}) => {
    const queryClient = useQueryClient();

    return (
        <Form<FormValues>
            initialValues={{formatovanaLegenda: topic.formatovanaLegenda}}
            onSubmit={async data => {
                return await rffFormSubmit(async () => {
                    // updateTopicSettings přepisuje všechna posílaná pole naráz, proto posíláme i výchozí vrstvy,
                    // aby se úpravou legendy nepřemazaly (stejný princip jako u výběru výchozího podkladu).
                    await LayerSettingsApi.updateTopicSettings(topic.id, {
                        id: topic.id,
                        nazev: topic.label,
                        defaultBackgroundLayer: topic.defaultBackgroundLayer,
                        defaultForegroundLayer: topic.defaultForegroundLayer,
                        formatovanaLegenda: data.formatovanaLegenda,
                    });
                    await queryClient.invalidateQueries([CACHE_KEY_TOPICS_MAP]);
                    mapRef.current.updateTopic(topic.id);
                    onClose();
                });
            }}
        >
            {({handleSubmit, submitting}) => {
                return (
                    <Dialog size={'xl'} onClose={onClose} title={'Rozšířená legenda tématu'}>
                        <DialogBody>
                            <Card mode={'edit'}>
                                <Block>
                                    <VF.Wysiwyg
                                        name={'formatovanaLegenda'}
                                        label={'Formátovaný text legendy'}
                                        disabled={submitting}
                                    />
                                </Block>
                            </Card>
                        </DialogBody>
                        <DialogFooter>
                            <Button disabled={submitting} style={'link'} onClick={onClose}>
                                Zrušit
                            </Button>
                            <Button style={'primary'} disabled={submitting} onClick={handleSubmit}>
                                Uložit
                            </Button>
                        </DialogFooter>
                    </Dialog>
                );
            }}
        </Form>
    );
};
